import { handleActions } from 'redux-actions';

import { type resourceStoreTypes, resourceUpserters } from '../core';
import type { HousingSelectionType } from '../housing-selection/housingSelectionTypes';
import * as actions from './houseStatsActions';
import { mkHouseStore } from './houseStatsTypes';

const houseStatsReducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<HousingSelectionType>,
  | ReturnType<typeof actions.getHouseData>
  | ReturnType<typeof actions.getHouseDataSuccess>
  | ReturnType<typeof actions.getHouseDataFailure>
>(
  {
    [actions.getHouseData.type]: (state) => state.set('isLoading', true),
    [actions.getHouseDataSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResources(state, payload.set('replaceCollection', true)),
    [actions.getHouseDataFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  mkHouseStore({ resourceName: 'HOUSESTATS' }),
);

export default houseStatsReducer;
